import { DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutWireFundsProcessingDetail extends Layout {
    panelDeduct: Panel;
    panelOtherCharge: Panel;
    panelSwitches: Panel;
    sourceUnpostedWire: DataSource;
    switchDeduct: Switch;
    switchOtherCharge: Switch;
    textboxChargeAmt: Textbox;
    textboxChargeCodeId: Textbox;
    textboxCheckAmount: Textbox;
    textboxCheckCode: Textbox;
    textboxCheckNumber: Textbox;
    textboxDeductCodeId: Textbox;
    textboxDeductStatus: Textbox;
    textboxDeductTotal: Textbox;
    textboxDescr: Textbox;
    textboxDriverFeeAmt: Textbox;
    textboxDriverId: Textbox;
    textboxFuelCardId: Textbox;
    textboxIfuelQuikqAssetId: Textbox;
    textboxMovementId: Textbox;
    textboxOrderId: Textbox;
    textboxPayeeId: Textbox;
    textboxServiceCharge: Textbox;
    textboxStatus: Textbox;
    textboxSubaccountId: Textbox;
    textboxTransDateTime: Textbox;
    textboxUserId: Textbox;
    textboxWireContractTch: Textbox;
    textboxWirecodeId: Textbox;
}
